<template>

  <!--预约须知-->
  <div class="alert-box">
    <div class="mask"></div>
    <div class="alert-con curr">
      <img class="close" src="../assets/icon-close.png" alt="" @click="closeFun" v-if="type=='desc'">
      <p class="tit font34 bold cor3">{{curritem.name}}</p>
      <div class="alert-desc border-box p40" v-html="curritem.info" id="descinfo"></div>

      <p class="btn linear" v-if="type=='desc'" @click="closeFun">关闭</p>
      <p class="btn linear" :class="ruletime>0?'disabled':''" v-if="type=='rule'" @click="closeFun"><font v-if="ruletime>0">{{ruletime}}s</font> 我已阅读(同意)</p>
    </div>
  </div>

</template>

<script>

  import { } from "@/service/getData";
  import {setStore, getStore, removeStore} from '@/config/mUtils'
  import {routeUrl,isPhonebind} from '@/utils/wechat'
  import D from '@/wc-messagebox'
  import Vue from 'vue'
  Vue.use(D)

  export default {
    data(){
      return{
        userInfo: {},
        TimeStamp: new Date().getTime(),  //获取当前时间

        ruletime: 5, //type=='rule'时，倒计时
      }
    },
    created(){
      var self = this;
      if(self.type=='rule'){
        var timer = setInterval(function(){
          self.ruletime--;
          if(self.ruletime<=0){
            clearInterval(timer);
            timer = null;
          }
        },1000);
      }else {
        self.ruletime = 0;
      }
    },
    props: ['type','curritem','ordernum'],
    computed: {

    },
    methods: {

      //关闭弹窗
      closeFun:function(){
        if(this.type=='rule'){
          if(this.ruletime<=0){
            if(this.ordernum){
              this.$emit('child-orderKnow',{close:0,msg:1,ordernum:this.ordernum});
            }else {
              this.$emit('child-orderKnow',{close:0,msg:1});
            }
          }
        }else {
          this.$emit('child-orderKnow',{close:0,msg:0});
        }


      },

      //预约下单
      toOrder:function (){
        var self = this;

      },

    },
  }
</script>

<style scoped>
  .alert-box{position: fixed;top:0;left: 0;z-index:1000;width: 100vw;height: 100vh;}
  .alert-box .close{position: absolute;top:.4rem;right: .4rem;width: auto;height: .28rem;}
  .alert-box .mask{position: absolute;left: 0;top:0;width: 100%;height: 100%;background: rgba(0,0,0,.6);}
  .alert-box .alert-con{position: absolute;left: 0;right:0;bottom: -100%;padding-top:.4rem;background: #fff;border-radius: .22rem .22rem 0 0;}
  .alert-box .alert-con.curr{-webkit-animation: alertShow .3s linear;animation: alertShow .3s linear;-webkit-animation-fill-mode: forwards;animation-fill-mode: forwards;}
  .alert-box .alert-con .tit{text-indent: .4rem;line-height: 1;}
  .btn { height: .7rem; margin-left: .16rem; font: .32rem/.7rem Microsoft YaHei; color: #fff; border: 1px solid #feca50; border-radius: .5rem; text-align: center; }
  .alert-con .btn{ display: block; width: auto; margin: .1rem .4rem .2rem;}
  .alert-desc{ position: relative; max-height: 76vh;padding:0 .4rem .4rem;margin-top:.3rem;overflow-y: auto;color: #333;}
  .alert-desc img{max-width: 100%!important;}
  @-webkit-keyframes alertShow {from{bottom: -100%;}to{bottom:0;}}
  @keyframes alertShow {from{bottom: -100%;}to{bottom:0;}}
  .btn.disabled{border: 1px solid #e3e3e3;}

</style>
<style>
  #descinfo img{max-width: 100%!important;}
</style>




// WEBPACK FOOTER //
// src/components/AlertOrderKnow.vue